import { PublicationAdvancedFilter } from "../../../misc/pagedFilter";
import { PublicationResult } from "../../../models/workflow.model";
import { callService, serviceReducer } from "../../../hooks/serviceReducer";
import { Action, ApiState } from "../../../misc/api.types";

export type ResultAction =
  | Action<PublicationResult>
  | { type: "PAGE"; value: number }
  | { type: "PAGE_SIZE"; value: number }
  | { type: "SEARCH"; value: PublicationAdvancedFilter }
  | { type: "ORDER"; column: string; sortDescending: boolean };

const reducer = (
  state: ApiState<PublicationResult, PublicationAdvancedFilter>,
  action: ResultAction
): ApiState<PublicationResult, PublicationAdvancedFilter> => {
  switch (action.type) {
    case "PAGE": {
      return callService(state, { ...state.filter, pageNumber: action.value });
    }
    case "PAGE_SIZE": {
      return callService(state, {
        ...state.filter,
        pageNumber: 1,
        pageSize: action.value,
      });
    }
    case "SEARCH": {
      return callService(state, { ...state.filter, ...action.value });
    }
    case "ORDER": {
      return callService(state, {
        ...state.filter,
        sortField: action.column,
        sortDescending: action.sortDescending,
      });
    }
    default:
      return serviceReducer(state, action);
  }
};

export default reducer;
